import { useContext, useState } from "react";
import AppContext from "../context";
import DID from "./designer/did";
import Dimensions from "./designer/dimensions";
import Materials from "./designer/materials";
import Menu from "./designer/menu";
import Navigation from "./designer/navigation";
import Settings from "./designer/settings";
import InsertName from "./designer/insertName";
import ToCheckout from "./designer/toCheckout";
import Toolbar from "./designer/toolbar";
import OrderSummary from "./orderSummary";
import Videos from "./designer/videos";
import Bottoms from "./designer/bottoms";
import { notify, returnShopifyProductPrice } from "../util/helpers";
import defaultInsert from "../content/default-insert.json";

const Designer = ({ loading }) => {
  const {
    orderState,
    editedItem,
    sides,
    bottom,
    bottomRequired,
    smallKnifeBlocks,
    largeKnifeBlocks,
    spiceRacks,
    insertName,
    selectedMaterial,
    currentInsertDimensions,
    defaultBaseProduct,
    setEditedItem,
    handleSetGlobalModal,
    triggerDimensionsUpdate,
    handleSetBottomRequired,
    materials,
    handleSetSelectedMaterial,
    handleSetSelectedBottomType,
    handleSetSelectedBottomColor,
    editInsertInCart,
  } = useContext(AppContext);
  const [imperial, setImperial] = useState(true);
  const [widthError, setWidthError] = useState(false);
  const [depthError, setDepthError] = useState(false);
  const [heightError, setHeightError] = useState(false);

  const handleSetWidthError = (bool) => {
    setWidthError(bool);
  };
  const handleSetDepthError = (bool) => {
    setDepthError(bool);
  };
  const handleSetHeightError = (bool) => {
    setHeightError(bool);
  };
  const handleSetImperial = (bool) => {
    setImperial(bool);
  };

  const saveChanges = () => {
    let svgs = window?.saveSVGs?.();
    if (!bottomRequired && svgs.base) delete svgs.base;
    const additionalBlocksPrice =
      smallKnifeBlocks.quantity * smallKnifeBlocks.price +
      largeKnifeBlocks.quantity * largeKnifeBlocks.price +
      spiceRacks.quantity * spiceRacks.price;
    const insert = {
      id: editedItem.id,
      title: insertName || editedItem.title,
      bottomRequired,
      smallKnifeBlocks,
      largeKnifeBlocks,
      spiceRacks,
      sides,
      bottom: bottomRequired ? bottom : null,
      price: bottomRequired
        ? sides.sidesPrice +
          bottom.price +
          returnShopifyProductPrice(defaultBaseProduct) +
          additionalBlocksPrice
        : sides.sidesPrice +
          returnShopifyProductPrice(defaultBaseProduct) +
          additionalBlocksPrice,
      material: selectedMaterial,
      baseProduct: defaultBaseProduct,
      quantity: editedItem.quantity,
      dimensions: currentInsertDimensions,
      svgs,
    };

    editInsertInCart(insert);
    notify(`Changes saved to "${insert.title}"!`, "success");
    setEditedItem(null);
  };

  const cancelEditing = () => {
    setEditedItem(null);
    handleSetBottomRequired(true);
    window?.checkBottomRequired();
    const defaultMaterial = materials.find((material) =>
      material.node.tags.includes("default-material")
    );
    handleSetSelectedBottomType("wood");
    handleSetSelectedBottomColor(null);
    if (defaultMaterial) handleSetSelectedMaterial(defaultMaterial.node);
    handleSetGlobalModal(null, { forceClose: true });
    window?.loadInsert?.(JSON.stringify(defaultInsert));
    setTimeout(() => {
      triggerDimensionsUpdate();
    }, 250);
  };

  return (
    <>
      <div className="designer" style={{ margin: "1rem" }}>
        <div className={orderState ? "is-hidden" : ""}>
          {/* <Fade duration={250}> */}
          <Menu position="left">
            <Toolbar />
            <Settings />
            <Videos />
          </Menu>
          {/* </Fade> */}
        </div>
        <DID />
        {editedItem && (
          <div className="designer__edit-mode">
            <p>
              You are currently editing <strong>{editedItem.title}</strong>
            </p>
            <button className="button is-success" onClick={saveChanges}>
              Save Changes
            </button>
            <button
              className="button is-danger"
              onClick={() =>
                handleSetGlobalModal(
                  <div className="common-modal">
                    <div className="common-modal__content content">
                      <h2 style={{ textAlign: "center" }}>
                        Are you sure you want to cancel editing <br />
                        <strong>{editedItem.title}</strong>?
                      </h2>
                      <div className="buttons">
                        <button
                          className="button is-success"
                          onClick={cancelEditing}
                        >
                          Yes
                        </button>
                        <button
                          className="button is-danger"
                          onClick={() => {
                            handleSetGlobalModal(null, {
                              forceClose: true,
                            });
                          }}
                        >
                          No
                        </button>
                      </div>
                    </div>
                  </div>
                )
              }
            >
              Cancel
            </button>
          </div>
        )}
        <div className={orderState ? "is-hidden" : ""}>
          {/* <Fade duration={250}> */}
          <Menu position="right">
            <div className="is-flex is-justify-content-flex-start is-flex-direction-column fullheight">
              {/* <ToCheckout loading={loading} /> */}
              <div>
                <InsertName />
                <Dimensions
                  imperial={imperial}
                  widthError={widthError}
                  depthError={depthError}
                  heightError={heightError}
                  handleSetImperial={handleSetImperial}
                  handleSetWidthError={handleSetWidthError}
                  handleSetHeightError={handleSetHeightError}
                  handleSetDepthError={handleSetDepthError}
                />
                <Materials
                  imperial={imperial}
                  handleSetWidthError={handleSetWidthError}
                  handleSetHeightError={handleSetHeightError}
                  handleSetDepthError={handleSetDepthError}
                />
                <Bottoms />
                <Navigation />
              </div>
            </div>
          </Menu>
          {/* </Fade> */}
        </div>
        {orderState ? <OrderSummary /> : null}
      </div>
    </>
  );
};

export default Designer;
